export default "__VITE_ASSET__BvVtumlM__"